declare const fbq: any;

export const useCartTracker = () => {
  const { gtag } = useGtag();
  const auth = useAuth();

  const trackEvent = (event: string, data: object) => {
    const { isAuthenticated, user } = auth;
    const userDetail = isAuthenticated && {
      user_name: user.first_name,
      user_phone: user.phone,
      user_email: user.email
    };

    if (import.meta.client && typeof fbq !== 'undefined') {
      fbq('track', event, { ...data, ...userDetail });
    }
  };
  return { trackEvent };
};